import { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';

import CommentQuestion from './CommentQuestion';
import CreateQuestion from './CreateQuestion';
import QuestionsGate from './QuestionsGate';
import QuestionsList from './QuestionsList';

function Questions() {
  const client = useClient();
  const [taxonomies, setTaxonomies] = useState([]);
  const [phase, setPhase] = useState('gate'); // 'gate' | 'list'
  const [filters, setFilters] = useState({});

  useEffect(() => {
    client
      .fetch('taxonomies/used_by_questions')
      .then(({ data }) => setTaxonomies(data || []))
      .catch(() => setTaxonomies([]));
  }, []);

  return phase === 'gate' ? (
    <QuestionsGate
      taxonomies={taxonomies}
      onApply={f => {
        setFilters(f);
        setPhase('list');
      }}
    />
  ) : (
    <QuestionsList
      filters={filters}
      onBack={() => setPhase('gate')}
    />
  );

  /*
   * Botão "Nova questão" intencionalmente removido:
   * Banco populado via pipeline IA + revisão pedagógica.
   * Criação manual fica fora desta tela.
   */
}

export { Questions as default, CreateQuestion, CommentQuestion };
